import { getMonth, getYear } from 'date-fns';

import { DateOptions } from 'coreOld/enums';
import { IDateOption } from 'coreOld/types';
import { getLastDayOfMonth } from 'coreOld/utils';

export const DATE_FORMAT = 'YYYY-MM-DD';

const today = new Date();
const currentYear = getYear(today);
const currentMonth = new Date(`${getMonth(today) + 1}/01/${currentYear}`);
const lastMonth = new Date(`${getMonth(today)}/01/${currentYear}`);

export const dateOptions: IDateOption[] = [
  {
    id: 0,
    value: null,
    label: DateOptions.ALL,
  },
  {
    id: 1,
    value: { startDate: today, endDate: today },
    label: DateOptions.TODAY,
  },
  {
    id: 2,
    value: {
      startDate: currentMonth,
      endDate: getLastDayOfMonth(today),
    },
    label: DateOptions.THIS_MONTH,
  },
  {
    id: 3,
    value: {
      startDate: lastMonth,
      endDate: getLastDayOfMonth(lastMonth),
    },
    label: DateOptions.LAST_MONTH,
  },
  {
    id: 4,
    value: null,
    label: DateOptions.CUSTOM_RANGE,
  },
];
